import { Fragment } from 'react'
import { Tooltip } from 'antd'

const manageEmployeeErrorTableSchema = ({ data, headers, ellipseFlag = true, showError = false }) => {
  const { errors } = data
  const rowerror = errors && errors['rowerror']

  const HOC = ({ children }) =>
    !rowerror ? (
      <Tooltip placement='top' title={rowerror}>
        {children}
      </Tooltip>
    ) : (
      <Fragment>{children}</Fragment>
    )

  return (
    <HOC>
      <tr className='text-gray-600 text-xs' style={rowerror ? { border: '1px solid #E8432C', background: '#fcebea' } : {}}>
        { showError && errors &&( !rowerror ?
          <td className='py-3 px-3 text-red-600 font-semibold'>
            {errors[Object.keys(errors)[0]] || 'Relation Exceeds'} {Object.keys(errors).length > 1 && <span className='rounded-full bg-red-700 p-1 font-semibold text-xs text-white'>+{Object.keys(errors).length - 1}</span> }
          </td> 
          : 
          <td className='py-3 px-3 text-red-600 font-semibold'>
            {rowerror}
          </td>) 
        }
        {headers.map((header, ind) => {
          let text = data[header] || ''
          return errors && !rowerror && errors[header] ? (
            <Tooltip key={header} placement='right' title={errors[header]}>
              <td className='p-3 bg-red-100 border  text-gray-600 border-red-600'>
                <span className='font-semibold'>{text.length > 18 && ellipseFlag && header !== 'email' ? text.substr(0, 18) + '...' : text}</span>
              </td>
            </Tooltip>
          ) : (
            <td className='p-3' key={header}>
              <span>{text.length > 18 && ellipseFlag && header !== 'email' ? text.substr(0, 18) + '...' : text}</span>
            </td>
          )
        })}
      </tr>
    </HOC>
  )
}

export default manageEmployeeErrorTableSchema
